import React from 'react';
import { useRouteMatch } from 'react-router';

import { ValidacaoIR } from 'pages/Reports/ValidacaoIR';

import { Route } from '../Route';

export const ControleIRRoutes = () => {
  const { path } = useRouteMatch();

  return (
    <>
      <Route isPrivate path={`${path}/validacao-ir`} component={ValidacaoIR} />
    </>
  );
};
